import { CALL_STATUSES, getCallStatusKey, isKnownCallStatus } from './callStatus';

export const AI_CALLS_PATH = '/ai-assistant/calls';

const DATE_FILTER_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

function normalizeDateFilter(value) {
  if (!value || !DATE_FILTER_PATTERN.test(value)) {
    return '';
  }

  const parsed = new Date(`${value}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) {
    return '';
  }

  return value;
}

function normalizeStatusFilter(value) {
  if (!value || value === 'all') return 'all';
  const match = CALL_STATUSES.find(
    (status) => getCallStatusKey(status) === getCallStatusKey(value),
  );
  return match && isKnownCallStatus(match) ? match : 'all';
}

export const parseAICallsSearchParams = (searchParams) => ({
  candidateSearch: searchParams.get('q') || '',
  dateFilter: normalizeDateFilter(searchParams.get('date') || ''),
  statusFilter: normalizeStatusFilter(searchParams.get('status') || 'all'),
});

export const buildAICallsSearchParams = ({
  candidateSearch = '',
  dateFilter = '',
  statusFilter = 'all',
} = {}) => {
  const params = new URLSearchParams();
  const query = candidateSearch.trim();
  const status = normalizeStatusFilter(statusFilter);

  if (query) params.set('q', query);
  if (dateFilter) params.set('date', dateFilter);
  if (status && status !== 'all') params.set('status', status);

  return params;
};

export const getAICallsPath = (filters = {}) => {
  const params = buildAICallsSearchParams(filters);
  const query = params.toString();
  return query ? `${AI_CALLS_PATH}?${query}` : AI_CALLS_PATH;
};

export const getAICallsPathFromSearchParams = (searchParams) => {
  const query = searchParams.toString();
  return query ? `${AI_CALLS_PATH}?${query}` : AI_CALLS_PATH;
};

export const getAIReturnPathFromLocation = (location) => {
  if (!location?.pathname) {
    return AI_CALLS_PATH;
  }

  return `${location.pathname}${location.search || ''}`;
};
